module.exports = __webpack_public_path__ + "img/zhenti_normal.dec78504.png";